import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Switch,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Autocomplete,
  Stack,
  CircularProgress,
  Backdrop,
  Alert
} from "@mui/material";
import {
  ArrowBack as ArrowBackIcon,
  AddCircle as AddCircleIcon,
  Delete as DeleteIcon,
  Send as SendIcon,
  AttachFile as AttachFileIcon
} from "@mui/icons-material";
import axios from "axios";
import { Link, useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import SunEditor, { buttonList } from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { BASE_URL, domain } from "../../variables/api";

const Publish = (props) => {
  let navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    id: id,
    sendfrom: "",
    sendto: [],
    filter: false,
    grades: [],
    departments: [],
    subject: "",
    body: "",
    Attachment: [],
    publishedby: "",
    filtereddept: "",
    filteredgrades: "",
    ismandatory: 0,
    specificEmails: ""
  });

  const [count, setCount] = useState(0);
  const [gradesOptions, setGradesOptions] = useState([]);
  const [departmentsOptions, setDepartmentsOptions] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [showDepartments, setShowDepartments] = useState(false);
  const [showSpecificEmails, setShowSpecificEmails] = useState(false);
  const [isPublished, setIsPublished] = useState(false);

  const sentToOptions = [
    { value: "Students_personal_Email", label: "Students personal Email" },
    { value: "Students_IVY_Email", label: "Students Email" },
    { value: "Parents", label: "Parents" },
    { value: "Test_Email", label: "Test Email" },
    { value: "IVY_All_Staff", label: "All Staff" },
    { value: "Departments", label: "Departments" },
    { value: "Specific_Emails", label: "Specific Emails" },
  ];

  useEffect(() => {
    setLoading(true);
    
    const fetchPublishedSurvey = axios.post(`${BASE_URL}/surveys/getpublishedsurvey.php`, { id: id });
    const fetchGrades = axios.get(`${BASE_URL}/surveys/getgrades.php`);
    
    Promise.all([fetchPublishedSurvey, fetchGrades])
      .then(([publishedRes, gradesRes]) => {
        // Handle published survey data
        let publishedSurvey = publishedRes.data.data;
        if (publishedSurvey) {
          setIsPublished(Number(publishedSurvey.is_published) === 1);
          setFormData((prevState) => ({
            ...prevState,
            subject: publishedSurvey.subject ?? "",
            body: publishedSurvey.body ?? "",
            sendfrom: publishedSurvey.sendfrom ?? "",
            Attachment: publishedSurvey.attachments ?? [],
            publishedby: publishedSurvey.publishedby ?? "",
            filtereddept: publishedSurvey.filterdept ?? "",
            filteredgrades: publishedSurvey.filtergrades ?? "",
            filter: publishedSurvey.filtergrades !== "" ? true : false,
            ismandatory: publishedSurvey.ismandatory ? 1 : 0,
            grades: [],
            departments: [],
            specificEmails: ""
          }));

          let filtered = [];
          try {
            const savedSendTo = JSON.parse(publishedSurvey.sendto || "[]");
            filtered = Array.isArray(savedSendTo)
              ? savedSendTo.map(item => typeof item === "string" ? item : item.value)
              : [];
          } catch (error) {
            // Support records saved by the previous comma-separated format.
            filtered = publishedSurvey.sendto?.split(",") || [];
          }
          let newSendTo = [];
          if (filtered.includes("Test_Email")) {
            const testOption = sentToOptions.find(opt => opt.value === "Test_Email");
            newSendTo = [{ ...testOption, response: true }];
          } else {
            sentToOptions.forEach(opt => {
                if (filtered.includes(opt.value)) {
                    newSendTo.push({ ...opt, response: true });
                }
            });
          }
          
          setFormData(prev => ({ ...prev, sendto: newSendTo }));
          checkVisibility(newSendTo);
        }

        // Handle grades data
        const gradeOptions = gradesRes.data.data?.grades.map((option) => ({
          value: option.id,
          label: option.grade,
        }));
        const departmentOptions = gradesRes.data.data?.departments.map((option) => ({
          value: option.id,
          label: option.department,
        }));
        setGradesOptions(gradeOptions || []);
        setDepartmentsOptions(departmentOptions || []);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  const checkVisibility = (sendToArray) => {
      const hasStudentOrParent = sendToArray.some(x => 
          ['Students_personal_Email', 'Students_IVY_Email', 'Parents'].includes(x.value) && x.response
      );
      setShowFilter(hasStudentOrParent);

      const hasDepartments = sendToArray.some(x => x.value === 'Departments' && x.response);
      setShowDepartments(hasDepartments);

      const hasSpecificEmails = sendToArray.some(x => x.value === 'Specific_Emails' && x.response);
      setShowSpecificEmails(hasSpecificEmails);
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const checked = event.target.checked;

    if (name === "ismandatory") {
        setFormData(prev => ({ ...prev, ismandatory: checked ? 1 : 0 }));
    } else if (name === "filter") {
        setFormData(prev => ({ ...prev, filter: checked }));
    } else {
        setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSendToChange = (event, optionValue) => {
      const checked = event.target.checked;
      let currentSendTo = [...formData.sendto];
      
      if (checked) {
          if (optionValue === "Test_Email") {
              const testOption = sentToOptions.find(x => x.value === "Test_Email");
              currentSendTo = [{ ...testOption, response: true }];
          } else if (!currentSendTo.find(x => x.value === optionValue)) {
              const opt = sentToOptions.find(x => x.value === optionValue);
              currentSendTo.push({ ...opt, response: true });
          }
      } else {
          // Remove
          currentSendTo = currentSendTo.filter(x => x.value !== optionValue);
      }

      setFormData(prev => ({ ...prev, sendto: currentSendTo }));
      checkVisibility(currentSendTo);
  };

  const handleSelectChange = (event) => {
      setFormData(prev => ({ ...prev, sendfrom: event.target.value }));
  };

  const handleSuneidtorChange = (content) => {
    setFormData(prev => ({ ...prev, body: content }));
  };

  const addAttachement = () => {
    const newAttachment = { id: `attachment-${count}`, file: null };
    setFormData(prev => ({ ...prev, Attachment: [...prev.Attachment, newAttachment] }));
    setCount(count + 1);
  };

  const handleChangeAttachement = (e, attachmentId) => {
      if (e.target.files && e.target.files[0]) {
          const file = e.target.files[0];
          setFormData(prev => {
              const newAttachments = prev.Attachment.map(att => {
                  if (att.id === attachmentId) {
                      return { ...att, file: file };
                  }
                  return att;
              });
              return { ...prev, Attachment: newAttachments };
          });
      }
  };

  const handleRemoveattachment = (attachmentId) => {
      // If it's an existing attachment (has drive_id), call API
      const attachment = formData.Attachment.find(a => a.id === attachmentId);
      if (attachment && attachment.drive_id) {
          axios.post(`${BASE_URL}/surveys/deleteattachment.php`, { id: attachmentId })
              .then(() => {
                  setFormData(prev => ({
                      ...prev,
                      Attachment: prev.Attachment.filter(a => a.id !== attachmentId)
                  }));
              });
      } else {
          // Just remove from state
          setFormData(prev => ({
              ...prev,
              Attachment: prev.Attachment.filter(a => a.id !== attachmentId)
          }));
      }
  };

  const handleSubmitTicket = (e) => {
    e.preventDefault();
    if (isPublished) {
      Swal.fire({
        title: "Already Published",
        text: "This survey has already been published and cannot be published again.",
        icon: "warning",
        confirmButtonText: "Okay"
      });
      return;
    }
    Swal.showLoading();
    const surveyData = new FormData();
    
    // Append simple fields
    surveyData.append("id", formData.id);
    surveyData.append("sendfrom", formData.sendfrom);
    surveyData.append("subject", formData.subject);
    surveyData.append("body", formData.body);
    surveyData.append("ismandatory", formData.ismandatory);
    surveyData.append("filter", formData.filter);
    surveyData.append("specificEmails", formData.specificEmails);

    // Append arrays as JSON or specific format expected by backend
    // Original code:
    // Object.entries(formData).forEach(([key, value]) => ...
    // It seems it appends 'sendto' as JSON string of array of objects?
    // Let's replicate original logic roughly but cleaner
    
    surveyData.append("sendto", JSON.stringify(formData.sendto));
    surveyData.append("grades", JSON.stringify(formData.grades));
    surveyData.append("departments", JSON.stringify(formData.departments));

    // Attachments
    formData.Attachment.forEach(att => {
        if (att.file) {
            surveyData.append(att.id, att.file);
        }
    });

    axios
      .post(`${BASE_URL}/surveys/savemail.php`, surveyData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        const recipientCount = res?.data?.data?.recipient_count;
        const detail = testEmailSelected
          ? "The test email is being delivered. The survey remains unpublished."
          : Number.isInteger(recipientCount)
          ? `Email delivery started for ${recipientCount} recipient${recipientCount === 1 ? "" : "s"}.`
          : "Email delivery started in the background.";
        Swal.fire(testEmailSelected ? "Test Email Queued" : "Survey Published", detail, "success");
        navigate("/");
      })
      .catch((e) => {
        const message = e?.response?.data?.msg || "Failed to publish the survey.";
        const alreadyPublished = message.toLowerCase().includes("already published");
        Swal.fire(alreadyPublished ? "Already Published" : "Unable to Publish", message, alreadyPublished ? "warning" : "error");
      });
  };

  const testEmailSelected = formData.sendto.some(x => x.value === "Test_Email");

  let sendFromOptions = [];
  if (window.location.href.search("iatseg.org") !== -1) {
    sendFromOptions = [
      { value: "Survey", label: "Survey@iatseg.org" },
      { value: "noreply", label: "no-reply@iatseg.org" },
    ];
  } else {
    sendFromOptions = [
      { value: "Survey", label: "Survey@" + domain },
      { value: "admission", label: "Admission@" + domain },
      { value: "hr", label: "Hr@" + domain },
      { value: "noreply", label: "no-reply@" + domain },
      { value: "cafe", label: "Cafeteria@" + domain },
      { value: "club", label: "Club@" + domain },
      { value: "activity", label: "Activity@" + domain },
      { value: "academic", label: "Academic@" + domain },
      { value: "studentaffairs", label: "StudentAffairs@" + domain },
      { value: "principal", label: "Principal@" + domain },
      { value: "lowergrade", label: "LowerGrade@" + domain },
      { value: "transportation", label: "transportation@" + domain },
      { value: "ceo", label: "CEO@" + domain },
      { value: "drama", label: "Drama@" + domain },
      { value: "staffdevelopment", label: "Staffdevelopment@" + domain },
    ];
  }

  return (
    <Box sx={{ p: { xs: 0, sm: 1 }, maxWidth: 1200, margin: "0 auto" }}>
      {/* Loading Overlay */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <CircularProgress color="inherit" />
          <Typography variant="h6">Loading...</Typography>
        </Box>
      </Backdrop>
      <Button
        component={Link}
        to="/"
        startIcon={<ArrowBackIcon />}
        sx={{ mb: 3 }}
        variant="outlined"
      >
        Back
      </Button>

      <Typography variant="h4" gutterBottom fontWeight="bold">
        Publish Survey / Create Email
      </Typography>

      <Paper elevation={3} sx={{ p: 4 }}>
        {isPublished && (
          <Alert severity="warning" sx={{ mb: 3 }}>
            This survey has already been published. Publishing it again is not allowed.
          </Alert>
        )}
        <form onSubmit={handleSubmitTicket}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.ismandatory === 1}
                    onChange={(e) => handleChange(e)}
                    name="ismandatory"
                  />
                }
                label="Is Mandatory"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth required>
                <InputLabel>Sent From</InputLabel>
                <Select
                  value={formData.sendfrom}
                  label="Sent From"
                  onChange={handleSelectChange}
                  name="sendfrom"
                >
                  {sendFromOptions.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom>
                Send To:
              </Typography>
              <Grid container spacing={2}>
                {sentToOptions.map((opt) => (
                  <Grid item key={opt.value}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.sendto.some(x => x.value === opt.value)}
                          onChange={(e) => handleSendToChange(e, opt.value)}
                          disabled={testEmailSelected && opt.value !== "Test_Email"}
                        />
                      }
                      label={opt.label}
                    />
                  </Grid>
                ))}
              </Grid>
              {testEmailSelected && (
                <Alert severity="info" sx={{ mt: 2 }}>
                  Test mode sends only to your email address. The survey will remain unpublished.
                </Alert>
              )}
            </Grid>

            {showDepartments && (
              <Grid item xs={12}>
                <Autocomplete
                  multiple
                  options={departmentsOptions}
                  getOptionLabel={(option) => option.label}
                  value={formData.departments}
                  onChange={(event, newValue) => {
                    setFormData(prev => ({ ...prev, departments: newValue }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Departments" placeholder="Departments" />
                  )}
                />
              </Grid>
            )}

            {showFilter && (
              <Grid item xs={12}>
                <Box sx={{ border: 1, borderColor: 'divider', p: 2, borderRadius: 1 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.filter}
                        onChange={handleChange}
                        name="filter"
                      />
                    }
                    label="Filter by grades"
                  />
                  
                  {formData.filter && (
                    <Box sx={{ mt: 2 }}>
                      <Autocomplete
                        multiple
                        options={gradesOptions}
                        getOptionLabel={(option) => option.label}
                        value={formData.grades}
                        onChange={(event, newValue) => {
                          setFormData(prev => ({ ...prev, grades: newValue }));
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Select Grades" placeholder="Grades" />
                        )}
                      />
                    </Box>
                  )}
                </Box>
              </Grid>
            )}

            {showSpecificEmails && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Specific Emails"
                  name="specificEmails"
                  value={formData.specificEmails}
                  onChange={handleChange}
                  placeholder="Example: email1@example.com, email2@example.com"
                  helperText="Comma separated emails"
                  multiline
                  rows={2}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom>
                Body
              </Typography>
              <SunEditor
                setContents={formData.body}
                onChange={handleSuneidtorChange}
                setOptions={{
                  buttonList: buttonList.complex,
                  height: 300,
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6">Attachments</Typography>
                <Button
                  startIcon={<AddCircleIcon />}
                  onClick={(e) => { e.preventDefault(); addAttachement(); }}
                  variant="outlined"
                >
                  Add Attachment
                </Button>
              </Box>
              
              <TableContainer component={Paper} variant="outlined">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>File</TableCell>
                      <TableCell align="right">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {formData.Attachment.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={2} align="center">No attachments</TableCell>
                        </TableRow>
                    ) : (
                        formData.Attachment.map((att) => (
                          <TableRow key={att.id}>
                            <TableCell>
                              {att.drive_id ? (
                                <a
                                  href={att.drive_id.includes("https://") ? att.drive_id : `https://drive.google.com/uc?id=${att.drive_id}&export=download`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ textDecoration: 'none', color: '#1976d2' }}
                                >
                                  {att.filename}
                                </a>
                              ) : (
                                <Button
                                  component="label"
                                  startIcon={<AttachFileIcon />}
                                  size="small"
                                >
                                  {att.file ? att.file.name : "Select File"}
                                  <input
                                    type="file"
                                    hidden
                                    onChange={(e) => handleChangeAttachement(e, att.id)}
                                  />
                                </Button>
                              )}
                            </TableCell>
                            <TableCell align="right">
                              <IconButton
                                color="error"
                                onClick={() => handleRemoveattachment(att.id)}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>

            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                fullWidth
                startIcon={<SendIcon />}
              >
                {isPublished ? "Already Published" : testEmailSelected ? "Send Test Email" : "Publish"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Box>
  );
};

export default Publish;
